import { useState } from 'react';

export const useCalendlyAndVideo = () => {
  const [isCalendlyOpen, setIsCalendlyOpen] = useState(false);
  const [isVideoOpen, setIsVideoOpen] = useState(false);

  const openCalendly = () => setIsCalendlyOpen(true);
  const closeCalendly = () => setIsCalendlyOpen(false);
  const openVideo = () => setIsVideoOpen(true);
  const closeVideo = () => setIsVideoOpen(false);

  return {
    isCalendlyOpen,
    isVideoOpen,
    openCalendly,
    closeCalendly,
    openVideo,
    closeVideo,
  };
};
